<template>
  <v-select
    :items="items"
    :label="label"
    :hint="hint"
    :readonly="readonly"
    :value="value"
    :multiple="multiple"
    :rules="requiredRules"
    :class="styleClasses"
    item-text="label"
    item-value="value"
    @change="changeItem"
    @input="changeItem"
  >
  </v-select>
</template>
<script>
import { requiredRules } from '../../utils/rules'

export default {
  name: 'DateOperationsSelect',

  methods: {
    changeItem (event) {
      this.$emit('change', event)
    }
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  computed: {
    requiredRules () {
      return this.required ? requiredRules(this.value) : []
    },
    items () {
      return [
        {
          label: this.$t('core.dateoperationsselect.week.first.day'),
          value: 'FIRST_DAY_OF_WEEK'
        },
        {
          label: this.$t('core.dateoperationsselect.week.last.day'),
          value: 'LAST_DAY_OF_WEEK'
        },
        {
          label: this.$t('core.dateoperationsselect.week.first.business_day'),
          value: 'FIRST_BUSINESS_DAY_OF_WEEK'
        },
        {
          label: this.$t('core.dateoperationsselect.week.last.business_day'),
          value: 'LAST_BUSINESS_DAY_OF_WEEK'
        },
        {
          label: this.$t('core.dateoperationsselect.month.first_day'),
          value: 'FIRST_DAY_OF_MONTH'
        },
        {
          label: this.$t('core.dateoperationsselect.month.last_day'),
          value: 'LAST_DAY_OF_MONTH'
        },
        {
          label: this.$t('core.dateoperationsselect.year.first_day'),
          value: 'FIRST_DAY_OF_YEAR'
        },
        {
          label: this.$t('core.dateoperationsselect.year.last_day'),
          value: 'LAST_DAY_OF_YEAR'
        },
        {
          label: this.$t('core.dateoperationsselect.day.previous'),
          value: 'PREVIOUS_DAY'
        },
        {
          label: this.$t('core.dateoperationsselect.day.next'),
          value: 'NEXT_DAY'
        },
        {
          label: this.$t('core.dateoperationsselect.year.first_month'),
          value: 'FIRST_MONTH_OF_YEAR'
        },
        {
          label: this.$t('core.dateoperationsselect.year.last_month'),
          value: 'LAST_MONTH_OF_YEAR'
        },
        {
          label: this.$t('core.dateoperationsselect.month.previous'),
          value: 'PREVIOUS_MONTH'
        },
        {
          label: this.$t('core.dateoperationsselect.month.next'),
          value: 'NEXT_MONTH'
        }
      ]
    }
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    multiple: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    styleClasses: {
      type: String,
      default: null
    }
  }

}
</script>
